import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideRouterStore } from '@ngrx/router-store';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { metaReducers, reducers } from './core/store';
import { DashboardEffects } from './features/dashboard/store';
import { DocumentEffects } from './features/documents/store';
import { ApiKeysEffects } from './features/api-keys/store';
import { TemplatesEffects } from './features/templates/store';
import { BillingEffects } from './features/billing/store';
import { SettingsEffects } from './features/settings/store';
import { WebhookEffects } from './features/webhooks/store';
import { AnalyticsEffects } from './features/analytics/store';
import { UsageReportsEffects } from './features/usage-reports/store';
import { SupportEffects } from './features/support/store';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        loadingInterceptor
      ])
    ),
    provideAnimations(),
    provideStore(reducers, { metaReducers }),
    provideEffects([DashboardEffects, DocumentEffects, ApiKeysEffects, TemplatesEffects, BillingEffects, SettingsEffects, WebhookEffects, AnalyticsEffects, UsageReportsEffects, SupportEffects]),
    provideRouterStore(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75
    })
  ]
};

